import React, { Suspense } from 'react';
import { ActivityIndicator } from 'react-native';

import APIDocs from './components/Docs/API';
import Auth from './components/Auth';
import './config/i18n';
import ErrorBoundary from './components/ErrorBoundary';
import McadminChangePassword from './components/PTI/Mcadmin/ChangePassword';
import { ClientProvider, ClientContext } from './contexts/ClientContext';

import Main from './Main';
import PTI from './components/PTI';

const App = () => {
  if ('/docs/api' === window.location.pathname) {
    return <APIDocs />;
  }

  if ('/pti/mcadmin/change-password' === window.location.pathname) {
    return <McadminChangePassword />;
  }

  const ptiPath = window.location.pathname.startsWith('/pti');

  return (
    <ErrorBoundary>
      <Suspense fallback={<ActivityIndicator size="large" />}>
        <ClientProvider>
          <ClientContext.Consumer>
              {ctx => ctx.isLoggedIn ? (
                <ErrorBoundary>
                  {(ctx.apolloClientForPTI && ptiPath) ? (
                    <PTI />
                  ) : (
                    ctx.apolloClient ? (
                      <Main />
                    ) : (
                      <ActivityIndicator size="large" />
                    )
                  )}
                </ErrorBoundary>
              ) : (
                <Auth />
              )}
          </ClientContext.Consumer>
        </ClientProvider>
      </Suspense>
    </ErrorBoundary>
  );
};

export default App;
